(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function bindFooterAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll('.av-footer-toggle').forEach((button) => {
      if (button.dataset.avBound === 'true') return;
      button.dataset.avBound = 'true';

      const applyViewportState = () => {
        if (mobileQuery.matches) {
          if (button.dataset.avMobileReady !== 'true') {
            button.setAttribute('aria-expanded', 'false');
            button.dataset.avMobileReady = 'true';
          }
        } else {
          button.setAttribute('aria-expanded', 'true');
          delete button.dataset.avMobileReady;
        }
      };

      button.addEventListener('click', () => {
        if (!mobileQuery.matches) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
      });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', applyViewportState);
      } else {
        mobileQuery.addListener(applyViewportState);
      }
      applyViewportState();
    });
  }

  /* ---------- Mobile sticky purchase bar ----------
     Mirrors the real product form; never submits anything itself.
     - price: the selected variant's actual price (the sale price when the
       product is on sale — never the struck compare-at price)
     - summary: current pack size (pack selector) and selected length
     - shown only after the native buy buttons have scrolled up out of view,
       hidden again when they return or before they are reached
     - button state/label follow the native button (sold out, unavailable,
       loading) and a click simply clicks the native button */
  // A chosen multipack tile (snippets/alon-bundle-options) is what the form
  // adds: the bar shows that offer and its total, not the single-pack price.
  function chosenBundle(productInfo) {
    const input = productInfo.querySelector('[data-alon-bundles] [data-alon-qty]:checked');
    return input && parseInt(input.value, 10) > 1 ? input : null;
  }

  function stickyPrice(productInfo) {
    const bundle = chosenBundle(productInfo);
    if (bundle && bundle.getAttribute('data-total-label')) return bundle.getAttribute('data-total-label');
    const wrap = productInfo.querySelector('[id^="price-"]');
    // product-info hides the price for an unavailable combination: mirror that.
    if (!wrap || wrap.classList.contains('hidden')) return '';
    const price = wrap.querySelector('.price');
    if (!price) return '';
    const item = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular');
    return item ? item.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  // Pack size: the current row of the weight selector
  // (snippets/alon-weight-selector), else the size the pack selector states
  // for this product (data-alon-pack-size, snippets/alon-pack-selector), else
  // the product title.
  function stickySize(productInfo) {
    const row = productInfo.querySelector('[data-alon-weight] [aria-current="page"][data-alon-size]');
    if (row && row.getAttribute('data-alon-size')) return row.getAttribute('data-alon-size');
    const tile = productInfo.querySelector('.ap-pack.is-current .ap-pack__size');
    if (tile) return tile.textContent;
    const stated = productInfo.querySelector('[data-alon-pack-size]');
    if (stated && stated.getAttribute('data-alon-pack-size')) return stated.getAttribute('data-alon-pack-size');
    const heading = productInfo.querySelector('.product__title h1');
    return heading ? heading.textContent : '';
  }

  function stickySummary(productInfo) {
    const title = stickySize(productInfo).trim().replace(/\s+/g, ' ');
    const checked = productInfo.querySelector('variant-selects input[type="radio"]:checked');
    const staticValue = productInfo.querySelector('.ap-static-option__value');
    let option = checked ? checked.value : staticValue ? staticValue.textContent.trim() : '';
    const bundle = chosenBundle(productInfo);
    // A chosen offer's compact label (data-alon-short on label.ab-opt, e.g.
    // "4 מארזים · 3 + 1", snippets/alon-bundle-options) is shown on its own:
    // with the pack size in front it no longer fits a 320px bar.
    const shortEl = bundle && bundle.closest('[data-alon-short]');
    const short = shortEl ? (shortEl.getAttribute('data-alon-short') || '').trim() : '';
    if (short) return { title: '', option: short, optionEl: null };
    const bundleName = bundle && bundle.closest('.ab-opt') && bundle.closest('.ab-opt').querySelector('.ab-opt__name');
    if (bundleName) option = bundleName.textContent.trim().replace(/\s+/g, ' ');
    // The tile's own <bdi> (each number isolated, so "3+1" keeps the bought
    // count on the right, snippets/alon-bundle-options) is copied as it is.
    const optionEl = bundleName ? bundleName.querySelector(':scope > bdi') : null;
    return { title, option, optionEl };
  }

  // target: the product-info to bind (after a no-reload size switch the new
  // one, while the old one is still in the page for 500 ms); defaults to the
  // first main product-info.
  function setupStickyCart(target) {
    const existing = document.getElementById('av-mobile-sticky-cart');
    if (existing) existing.remove();
    document.body.classList.remove('av-sticky-cart-active');
    document.documentElement.classList.remove('av-sticky-cart-scroll');
    if (window.__avStickyCleanup) window.__avStickyCleanup();

    const productInfo =
      target && target.isConnected && target.matches && target.matches('product-info')
        ? target
        : document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return;
    const productForm = productInfo.querySelector('product-form');
    const nativeButton = () => productInfo.querySelector('.product-form__submit');
    if (!productForm || !nativeButton()) return;

    const bar = document.createElement('aside');
    bar.id = 'av-mobile-sticky-cart';
    bar.className = 'av-mobile-sticky-cart is-hidden';
    bar.setAttribute('aria-label', 'פעולת רכישה מהירה');

    const info = document.createElement('div');
    info.className = 'av-mobile-sticky-cart__info';
    const title = document.createElement('span');
    title.className = 'av-mobile-sticky-cart__title';
    const price = document.createElement('span');
    price.className = 'av-mobile-sticky-cart__price';
    info.append(title, price);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'av-mobile-sticky-cart__button';

    bar.append(info, button);
    document.body.appendChild(bar);

    let frame = 0;
    let errorShown = false;
    let visible = null;
    const sync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const current = nativeButton();
        if (!current) return;
        // An add-to-cart error is shown inside the (off-screen) product form:
        // bring the form into view once, so the message is actually seen.
        const errorWrap = productForm.querySelector('.product-form__error-message-wrapper');
        const hasError = !!errorWrap && !errorWrap.hasAttribute('hidden');
        if (hasError && !errorShown && visible) {
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          productForm.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        }
        errorShown = hasError;
        const label = current.querySelector('span');
        button.textContent = (label ? label.textContent : current.textContent).trim().replace(/\s+/g, ' ');
        button.disabled = current.disabled;
        button.classList.toggle('is-loading', current.getAttribute('aria-disabled') === 'true');
        price.textContent = stickyPrice(productInfo);
        const summary = stickySummary(productInfo);
        title.textContent = summary.title;
        if (summary.option) {
          if (summary.title) title.append(' · ');
          let bdi;
          if (summary.optionEl) {
            bdi = summary.optionEl.cloneNode(true);
          } else {
            bdi = document.createElement('bdi');
            bdi.textContent = summary.option;
          }
          title.append(bdi);
        }
      });
    };
    button.addEventListener('click', () => {
      const current = nativeButton();
      if (!current || current.disabled || current.getAttribute('aria-disabled') === 'true') return;
      current.click();
    });

    const setVisible = (next) => {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('is-hidden', !next);
      document.body.classList.toggle('av-sticky-cart-active', next);
      document.documentElement.classList.toggle('av-sticky-cart-scroll', next);
    };

    // Visible only once the buy buttons have scrolled up out of view. A
    // scroll check (rAF-throttled) rather than IntersectionObserver: an
    // observer misses jumps that skip over the buttons (fast flicks, anchor
    // links, "back to top"), which left the bar stuck on or off.
    let ticking = false;
    const evaluate = () => {
      ticking = false;
      // Mobile only: on wider screens the bar is not shown, and the body class
      // would needlessly move the WhatsApp button (alon-footer.liquid).
      setVisible(mobileQuery.matches && productForm.getBoundingClientRect().bottom < 0);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(evaluate);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onScroll);
    } else {
      mobileQuery.addListener(onScroll);
    }

    const buttonObserver = new MutationObserver(sync);
    buttonObserver.observe(productForm, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'],
      childList: true,
      characterData: true,
      subtree: true
    });
    const priceTarget = productInfo.querySelector('[id^="price-"]');
    const priceObserver = new MutationObserver(sync);
    if (priceTarget) {
      priceObserver.observe(priceTarget, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    const onChange = (event) => {
      if (event.target && event.target.closest && (event.target.closest('variant-selects') || event.target.closest('[data-alon-bundles]'))) sync();
    };
    productInfo.addEventListener('change', onChange);

    let unsubscribe = null;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, sync);
    }

    window.__avStickyCleanup = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (typeof mobileQuery.removeEventListener === 'function') {
        mobileQuery.removeEventListener('change', onScroll);
      } else {
        mobileQuery.removeListener(onScroll);
      }
      buttonObserver.disconnect();
      priceObserver.disconnect();
      productInfo.removeEventListener('change', onChange);
      if (unsubscribe) unsubscribe();
      window.__avStickyCleanup = null;
    };

    sync();
    evaluate();
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindFooterAccordions(document);
    setupStickyCart();
  });

  document.addEventListener('shopify:section:load', (event) => {
    bindFooterAccordions(event.target);
    window.setTimeout(setupStickyCart, 0);
  });

  // The package size was switched without a reload (assets/alon-weight-switch.js):
  // bind the bar to the new product form (the old bar is removed first).
  document.addEventListener('alon:product-swapped', (event) => {
    setupStickyCart(event.detail && event.detail.productInfo);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const toggle = event.target.querySelector('.av-footer-toggle');
    if (toggle && mobileQuery.matches) toggle.setAttribute('aria-expanded', 'true');
  });
})();
